import { Route, Switch, useLocation } from "react-router-dom"
import ROUTES from "./Routes"
import { ToastContainer } from "react-toastify"
import { useSelector } from "react-redux"
import SocketMessage from "../../container/SocketMessage"
import PatientEasyAccess from "../../component/PatientEasyAccess"
import PatientPageLock from "../../component/PatientPageLock"


export const ProtectedRoutes = (props) => {
    return (
        <Route {...props} />
    )
}
const AppRoutes = () => {
    const tokenData = useSelector((store) => store?.LOGIN_CREDS)
    const location = useLocation()
    let arr = location?.pathname?.split('/')
    let token
    if (arr[1] === 'admin') {
        token = tokenData?.adminTokenDetails?.access_token
    } else if (arr[1] === 'vendor') {
        token = tokenData?.vendorTokenDetails?.access_token
    } else {
        token = tokenData?.tokenDetails?.access_token
    }
    return (
        <div>
            <Switch>
                {ROUTES?.map(route => <ProtectedRoutes key={route.path} {...route} />)}
            </Switch>
            <PatientPageLock />
            <PatientEasyAccess />
            {!token && <ToastContainer />}
            {token && <SocketMessage />}
        </div>
    )
}

export default AppRoutes
